export const UPDATE_BSVCONFIG_STATE = 'UPDATE_BSVCONFIG_STATE'
export const UPDATE_BSVCONFIG_DATA = "UPDATE_BSVCONFIG_DATA"